import React from 'react';
import {Link} from 'react-router-dom';
class ItemList extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            colors: ['yellow','green','clean','blue','pink']
        }
    }
    componentDidMount(){

    }
    getColorRandom = () =>{
        let randomItem = this.state.colors[Math.floor(Math.random()*this.state.colors.length)];
        return randomItem;
    }
    render(){

        return(
            <div className="row d-flex flex-wrap mt-3">
                {
                    this.props.items.map((item,index) =>(
                        (index < 3 ? 
                        <div className="col-xs-6 col-md-4" key={index}>
                            <Link to={`/productos/${item.slug}`} className="category">
                                <div className={`d-flex mb-3 align-self-center ${this.getColorRandom()}`}>
                                    <div className="col-6 p-3"><h5>{item.name}</h5>
                                        {/* <small>45 Productos</small> */}
                                    </div>
                                    <div className="col-6 p-3">
                                        <img src={item.url_image} className="img-fluid" alt={item.name}/>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        :
                        <div className="col-xs-6 col-md-4" key={index}>
                            <Link to={`/productos/${item.slug}`} className="category">
                                <div className={`d-flex mb-3 align-self-center ${this.getColorRandom()}`}>
                                    <div className="col-6 p-3"><h5>{item.name}</h5>
                                        {/* <small>45 Productos</small> */}
                                    </div>
                                    <div className="col-6 p-3">
                                        <img src={item.url_image} className="img-fluid" alt={item.name}/>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        )
                    ))
                }

            </div>
            
        )
    }
}
export default ItemList;